// extracted by mini-css-extract-plugin
export default {"container":"bpoMenuPage_container__Ax48Z","mainContainer":"bpoMenuPage_mainContainer__JX0Ly","row":"bpoMenuPage_row__XBO6Y","lowerRow":"bpoMenuPage_lowerRow__j7r-H"};